module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qshou2-673745d814147417ceb5c11c52ef61eb.jpg";